// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fitness-restrictions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fitness-restrictions/fitness-restrictions.js';

mount([g0]);
